module.exports = __webpack_public_path__ + "img/menu_down.f7208797.svg";